{
  "navigationLinks": {
    "albums": "Albums",
    "audiences": "Audiences",
    "campanionStaffAccess": "Campanion Staff Access",
    "home": "Home",
    "integrations": "Integrations",
    "texting": "Texting",
    "microposts": "Microposts",
    "formReminders": "Form Reminders",
    "healthCheck": "Health Check",
    "registation": "Registration",
    "frDiagnostics": "FR Diagnostics",
    "taggedPhotoReport": "Tagged Photo Report",
    "facialRecognition": "Facial Recognition"
  },
  "navigationDividers": {
    "campminder": "CampMinder"
  },
  "legalLinks": {
    "privacyPolicy": "Privacy Policy",
    "termsOfService": "Terms of Service"
  }
}
